export default __webpack_public_path__ + "static/media/bell_active.15363de9.svg";